
import Warehouse from '@/models/common/warehouse.js'
import Expenses from "models/expenses";
const expenses = new Expenses();
import { commafy } from "@/common/js/util";
export default {
  data() {
    return {
      warehouseList: [],
      warehouseListCopy: [],
      // 获取各仓库的项目列表（树状）
      projectByWarehouseList: [],
      // 仓库库位列表
      warehouseLocationList: [],
      // 仓库实战面积列表
      warehouseRealAreaList: [],
    }
  },
  created() {
  },
  methods: {
    /**
     * @desc 获取所有仓库（不受权限控制）
     */
    async initAllWarehouseList() {
      let res = await Warehouse.getAllWarehouseList()
      if (res.success) {
        let arr = [];
        res.result.map(value => {
          let obj = {};
          obj.id = value.id;
          obj.name = value.name;
          obj.orderQuality = value.orderQuality;
          obj.warehouseCheck = false;
          obj.checkAll = false;
          obj.isIndeterminate = true;
          obj.projectIdList = [];
          arr.push(obj);
        });
        this.warehouseList = arr;
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        })
      }
    },


    /**
     * @desc 获取仓库数据
     */
    initWarehouse() {
      expenses.getWarehouseData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        } else {
          this.$message.error(res.message)
        }
      });
    },

    /**
     * @desc 获取仓库数据(同步)
     */
    async initAsyncWarehouse() {
      let res = await expenses.getWarehouseData()
      if (res.success) {
        let arr = [];
        res.result.map((value) => {
          let obj = {};
          obj.id = value.id;
          obj.name = value.name;
          arr.push(obj);
        });
        this.warehouseList = arr;
        this.warehouseListCopy = arr;
      } else {
        this.$message.error(res.message)
      }
    },


    /**
     * @desc 获取人工成本仓库数据(同步)
     */
    async initAsyncWarehouseLaborCost(data) {
      let res = await Warehouse.getWarehouseLaborCost(data)
      if (res.success) {
        let arr = [];
        res.result.map((value) => {
          let obj = {};
          obj.id = value.warehouseId;
          obj.name = value.warehouseName;
          obj.totalTimes = value.employeeHours;
          obj.employeeAmount = value.employeeAmount;
          obj.totalAmount = commafy(value.employeeAmount);
          arr.push(obj);
        });
        this.warehouseList = arr;
      } else {
        this.$message.error(res.message)
      }
    },

    /**
     * @desc 获取各仓库的项目列表（树状）
     */
    initProjectByWarehouse() {
      Warehouse.getProjectByWarehouse().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.warehouseName;
            obj.children = []
            value.projectList.map(i => {
              let childObj = {}
              childObj.id = i.id
              childObj.name = i.projectName
              obj.children.push(childObj)
            })
            arr.push(obj);
          });
          this.projectByWarehouseList = arr;
        } else {
          this.$message.error(res.message)
        }
      });
    },

    /**
     * @desc 获取仓库库位列表
     */
    async initWarehouseLocation() {
      let res = await Warehouse.getWarehouseLocation()
      if (res.success) {
        let arr = [];
        res.result.map((value) => {
          let obj = {};
          obj.id = value.warehouseId;
          obj.name = value.warehouseName;
          obj.warehouseLocationNums = value.num;
          obj.goodsShelves = value.shelveNum;
          obj.heaps = value.heapNum;
          arr.push(obj);
        });
        this.warehouseLocationList = arr;
      } else {
        this.$message.error(res.message)
      }
    },

    /**
     * @desc 获取仓库实占面积列表
     */
    async initWarehouseRealAreaList() {
      let res = await Warehouse.getWarehouseRealArea()
      if (res.success) {
        let arr = [];
        res.result.map((value) => {
          let obj = {};
          obj.id = value.id;
          obj.name = value.warehouseName;
          obj.warehouseArea = value.area;
          obj.realArea = value.userArea;
          arr.push(obj);
        });
        this.warehouseRealAreaList = arr;
      } else {
        this.$message.error(res.message)
      }
    }
  }
}